import * as API from "middleware/api";

export const getGeneralConditions = (idActivity, category, isLoggedIn, exchangeToken) =>
    (isLoggedIn
        ? API.executeWithAccessToken(`/${idActivity}`, { category })
        : API.executeWithExchangeToken(`/${idActivity}`, { category }, exchangeToken));

export const acceptGeneralConditions = (idActivity, idEnvironment, acceptConditions) =>
    API.executeWithAccessToken(`/${idActivity}`, { idEnvironmentToChange: idEnvironment, acceptConditions });
